/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DashboardItemTypes {
    Base = '0',
    DataTable = 1,
}
